import { OverlayModule } from '@angular/cdk/overlay';
import { NgModule } from '@angular/core';

import { WysiwygInlineButtonModule } from '../../wysiwyg-inline-button/wysiwyg-inline-button.module';
import { InsertPlaceholderInputDirective } from './insert-placeholder-input.directive';
import { InsertPlaceholderDirective } from './insert-placeholder.directive';
import { PlaceholderButtonComponent } from './placeholder-button/placeholder-button.component';
import { PlaceholderService } from './placeholder.service';
import { PlaceholdersListComponent } from './placeholders-list/placeholders-list.component';
import { WysiwygPlaceholderDropdownComponent } from './wysiwyg-placeholder/wysiwyg-placeholder-dropdown/wysiwyg-placeholder-dropdown.component';
import { WysiwygPlaceholderComponent } from './wysiwyg-placeholder/wysiwyg-placeholder.component';

@NgModule({
  imports: [WysiwygInlineButtonModule, OverlayModule],
  providers: [PlaceholderService],
  declarations: [
    InsertPlaceholderDirective,
    InsertPlaceholderInputDirective,
    PlaceholdersListComponent,
    WysiwygPlaceholderComponent,
    WysiwygPlaceholderDropdownComponent,
    PlaceholderButtonComponent,
  ],
  exports: [InsertPlaceholderDirective, InsertPlaceholderInputDirective, PlaceholdersListComponent],
})
export class WysiwygPlaceholderModule {}

export * from './insert-placeholder.directive';
export * from './insert-placeholder-input.directive';
export * from './placeholders-list/placeholders-list.component';
export * from './placeholder.service';
export * from './placeholder';
